module.exports = __webpack_public_path__ + "static/img/topbg-chengji.cf2aa6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/topbg-chengji.png
// module id = SAlu
// module chunks = 0